export type EditMode = "edit" | "create";

export const PRE_BOOKED_META_KEY = "pre_booked_product_id";

// Flera förbokningsprodukter lagras som "::"-separerat metadata-värde (samma
// separator som ApiBackend.buildQueryString använder för arrayer).
export const PRE_BOOKED_META_SEPARATOR = "::";